import { useEffect, useRef, useState } from 'react';

const useOnScreen = (ref, options = {}) => {
	const { threshold = 0, rootMargin = '0px' } = options;
	const [isOnScreen, setIsOnScreen] = useState(false);
	const observerRef = useRef(null);

	useEffect(() => {
		observerRef.current = new window.IntersectionObserver(([entry]) => {
			setIsOnScreen(entry.isIntersecting);
		}, { threshold, rootMargin });
	}, []);

	useEffect(() => {
		observerRef.current.observe(ref.current);

		return () => {
			observerRef.current.disconnect();
		};
	}, [ref]);

	return isOnScreen;
};

const useIsInView = (rootMargin = '0px', threshold = [0]) => {
	const [entry, setEntry] = useState(false);
	const ref = useRef();
	let timeoutTimer;

	useEffect(() => {
		const observer = new window.IntersectionObserver(([element]) => {
			setEntry(element);
		}, { rootMargin, threshold });

		const getRef = () => {
			if (!ref.current) {
				timeoutTimer = setTimeout(getRef, 200);
				return;
			}
			clearTimeout(timeoutTimer);
			observer.observe(ref.current);
		};

		getRef();

		return () => {
			observer.unobserve(ref.current);
		};
	}, [ref]);

	return [ref, entry];
};

const usePrevious = (value) => {
	const ref = useRef();

	useEffect(() => {
		ref.current = value;
	});

	return ref.current;
};

export { useOnScreen, useIsInView, usePrevious };
